<template>
    <div class="goodsGroupContent bgc box-shadow padding-20">
        <div class="tips_box">
            <p>{{ $route.query.name ? $route.query.name : '' }}</p>
            <p>创建时间：{{ $route.query.datetime ? $route.query.datetime : ''}}</p>
        </div>
        <div class="btn_box">
            <div class="commodity_group_btn_box">
                <el-button @click="addGoodsBtn" type="primary">增加商品</el-button>
            </div>
            <div class="search_btn_box">
                <div class="select_box">
                    <el-select v-model="statusValue" clearable placeholder="请选择">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <el-input placeholder="输入商品名称" v-model="goodsName" clearable></el-input>
                <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
            </div>
        </div>
        <div class="total_box">
            商品（{{total}}个）
        </div>
        <div class="table_box">
            <el-table :data="goodsListData" style="width: 100%">
                <el-table-column label="商品名称" width="300">
                    <template slot-scope="scope">
                        <div class="goods_box">
                            <img v-lazy="scope.row.logoPic.furl" alt="">
                            <p :title="scope.row.kmcname">{{scope.row.kmcname}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="divisionindex" label="排序" align='center'></el-table-column>
                <el-table-column prop="kmctypeText" label="类型" align='center'></el-table-column>
                <el-table-column label="状态" align='center'>
                    <template slot-scope="scope">
                        <span :class="statusClass(scope.row.status)">{{statusText(scope.row.status)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align='right'>
                    <template slot-scope="scope">
                        <div class="operation_box">
                            <!-- <span>
                                <el-popover trigger="click" placement="top" width="320" v-model="scope.row.visible">
                                    <div class="videoList-pr-code-upload padding-20">
                                        <img :src="scope.row.qrShare" :alt="scope.row.subject">
                                        <div class="pr-code-text cursor" @click="download(scope.row.qrShare, scope.row.subject)">下载二维码</div>
                                        <div class="btn-operate">
                                            <el-input v-model="scope.row.share" class="condition"></el-input>
                                            <el-button  type="primary" size="mini" v-clipboard:copy="scope.row.share" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                                        </div>
                                    </div>
                                    <span slot="reference">分享</span>
                                </el-popover>
                            </span>
                            <span>丨</span> -->
                            <span @click="removeGroupClick(scope.row.id)">移出分组</span>
                            <span>丨</span>
                            <span @click="sortClick(scope.row.id, scope.row.divisionindex)">排序</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </div>
        <AddGoodsTips ref="addShopTips" @getGoodsGroupInfo="getGoodsGroupInfo"></AddGoodsTips>
        <el-dialog title="商品排序" :visible.sync="goodsSortTips">
            <div class="goods_sort_box">
                <span>排序</span>
                <!-- <el-input v-model.number="goodsSortNum" @keyup.enter.native="sortHandleClick" maxlength=5></el-input> -->
                <input v-model="goodsSortNum" class="sortInput" oninput="if( this.value.length > 6 )  this.value = this.value.slice(0,6)" type="number">
                <label>序号越大，越靠后</label>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="goodsSortTips = false">取 消</el-button>
                <el-button type="primary" @click="sureSort()">保 存</el-button>
            </div>
        </el-dialog>
        <div class="right_help_box bgc padding-20" :class="showHelp ? 'show_helps_box' : 'hide_icon_box'" ref="helps">
            <div class="show_helps" :class="showHelp ? 'show_icon' : 'hide_icon'" @click="isShow()"></div>
            <div class="title_box">
                <span>基本信息</span>
                <span>进入></span>
            </div>
            <p>内容管理可添加哪些商品？</p>
            <p>可以添加图文、音频、视频、直播、专栏、大专栏、会员、分销商品。</p>
            <div class="issue_box">
                <ul>
                    <li><a href="#">商品分组使用教程</a></li>
                    <li><a href="#">能否批量添加商品？</a></li>
                    <li><a href="#">能否批量添加商品？</a></li>
                    <li><a href="#">添加完商品是否能自定义排序？</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {findGoodsGroupInfo, removeGroup, goodsSort} from 'api/materialMgtApi'
import Page from 'base/page/page'
import AddGoodsTips from 'views/shopMgt/goods/goodsTips/AddGoodsTips'
import {mapGetters, mapActions} from 'vuex'
import {promiseUrlToQRCode, downloadImage} from 'common/js/tools'
export default {
    name: 'goodsGroupContent',
    data() {
        return {
            goodsType: 1, // 商品类型
            goodsName: '',
            goodsSortNum: 0,
            goodsSortId: 0,
            goodsSortTips: false, // 商品排序弹窗
            total: 0,
            goodsListData: [],
            statusOptions: [
                {
                    value: '',
                    label: '全部状态'
                },
                {
                    value: 30,
                    label: '已上架'
                },
                {
                    value: 10,
                    label: '待上架'
                },
                {
                    value: 31,
                    label: '已下架'
                }
            ],
            statusValue: '',
            activeName: 'tuwen',
            showHelp: false // 右侧快捷帮助菜单
        }
    },
    mounted() {
        this.getGoodsGroupInfo()
    },
    methods: {
        download(imgsrc, name) { // 下载图片地址和图片名
            downloadImage(imgsrc, name)
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
            console.log(e.text)
        },
        onError(e) {
            alert('失败')
        },
        // 获取单个分组下商品列表
        getGoodsGroupInfo() {
            this.setLoading(true)
            var params = {
                divisioninnerid: this.$route.query.innerid
            }
            findGoodsGroupInfo({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.loading = false
                    this.goodsListData = data.data.content
                    this.total = data.data.pageinfo.rowCount

                    // this.goodsListData.forEach(obj => {
                    //     promiseUrlToQRCode('www.baidu.com', obj.logoPic.furl).then(
                    //         function(data) {
                    //             obj.qrShare = data
                    //         },
                    //         function(reason, data) {
                    //             console.log('二维码生成失败：', reason)
                    //         }
                    //     )
                    // })
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        // 添加商品按钮
        addGoodsBtn() {
            this.$refs.addShopTips.openDialog()
        },
        // 搜索
        searchClick() {
            this.setLoading(true)
            var params = {
                divisioninnerid: this.$route.query.innerid,
                kmcname: this.goodsName,
                status: this.statusValue
            }
            findGoodsGroupInfo({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.goodsListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // sortHandleClick() {
        //     this.goodsSortNum = this.goodsSortNum.replace(/[^\.\d]/g,'')
        //     this.goodsSortNum = this.goodsSortNum.replace('.','')
        // },
        // 排序
        sortClick(id, num) {
            this.goodsSortNum = num
            this.goodsSortId = id
            this.goodsSortTips = true
        },
        // 保存排序
        sureSort() {
            this.setLoading(true)
            var params = {
                id: this.goodsSortId,
                divisionindex: this.goodsSortNum
            }
            goodsSort({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.goodsSortTips = false
                    this.$message.success(`排序更新成功！`)
                    this.getGoodsGroupInfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.goodsSortTips = false
                    console.log('error：', data)
                }
            })
        },
        // 移出分组
        removeGroupClick(value) {
            this.$confirm('是否将该商品移出当前分组？', '移出分组', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var params = {
                    id: value
                }
                this.setLoading(true)
                removeGroup({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.$message.success(`商品移出成功!`)
                        this.getGoodsGroupInfo()
                    },
                    error: data => {
                        this.setLoading(false)
                        console.log('error：', data)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 删除
        shareClick(value) {},
        // 右侧快捷帮助菜单 显示/隐藏
        isShow() {
            this.showHelp = !this.showHelp
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        statusClass() {
            return function(value) {
                let cls = ''
                switch (value) {
                case 30:
                    cls = 'ysj'
                    break
                case 31:
                    cls = 'yxj'
                    break
                case 10:
                    cls = 'dsj'
                    break
                default:
                    cls = 'fail'
                }
                return cls
            }
        },
        statusText() {
            return function(value) {
                let cls = ''
                switch (value) {
                case 30:
                    cls = '· 已上架'
                    break
                case 31:
                    cls = '· 已下架'
                    break
                case 10:
                    cls = '· 待上架'
                    break
                case 0:
                    cls = '草稿'
                    break
                case 1:
                    cls = '待审核'
                    break
                case 11:
                    cls = '审核失败'
                    break
                case 100:
                    cls = '删除'
                    break
                case 12:
                    cls = '暂停'
                    break
                default:
                    cls = ' '
                }
                return cls
            }
        },
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {
        Page,
        AddGoodsTips
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .goodsGroupContent {
        position: relative;
        font-family:PingFangSC-Regular;
        padding-bottom: 100px;
        .tips_box{
            background:rgba(245,247,250,1);
            padding: 15px 20px;
            p:nth-of-type(1){
                color:rgba(96,98,102,1);
                height:20px;
                line-height:20px;
                margin-bottom: 4px;
            }
            p:nth-of-type(2){
                font-size:12px;
                color:rgba(144,147,153,1);
                line-height:17px;
            }
        }
        .btn_box{
            margin: 20px 0;
            display: flex;
            justify-content: space-between;
            .commodity_group_btn_box{
                .el-button, .el-button--mini {
                    height: 36px;
                    width: 110px;
                }
            }
            .search_btn_box{
                display: flex;
                .select_box{
                    margin-right: 20px;
                    .el-input__inner {
                        width: 147px;
                    }
                    .el-input__icon {
                        line-height: 0;
                    }
                }
                .el-input__inner {
                    height: 36px;
                    width: 240px;
                }
                .el-input__icon {
                    line-height: 36px;
                }
                .el-button, .el-button--mini {
                    height: 36px;
                    width: 96px;
                    margin-left: 20px;
                }
            }
        }
        .total_box{
            margin-bottom: 10px;
            color:rgba(48,49,51,1);
            line-height:20px;
            padding-left: 8px;
        }
        .table_box{
            .el-table th>.cell {
                color: #303133;
                // font-size: 16px;
                font-weight: bold;
            }
            .goods_box{
                display: flex;
                img{
                    width: 106px;
                    min-width: 106px;
                    height: 60px;
                }
                p{
                    margin-left: 10px;
                    height: 44px;
                    line-height:20px;
                    color:rgba(96,98,102,1);
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
            .ysj{
                color: #67C23A;
            }
            .yxj{
                color: #909399;
            }
            .dsj{
                color: #409EFF;
            }
            .fail{
                color: #909399;
            }
            .operation_box{
                min-width: 182px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                white-space: nowrap;
                span{
                    color: #409EFF;
                }
                span:nth-of-type(2n+1):hover{
                    cursor: pointer;
                    color: rgb(41, 138, 235);
                }
                span:nth-of-type(2n){
                    margin: 0 5px;
                }
            }
        }
        .goods_sort_box{
            display: flex;
            align-items: center;
            justify-content: center;
            padding-right: 20px;
            &>span{
                white-space: nowrap;
                margin-right: 10px;
                color: #303133;
            }
            &>label{
                margin-left: 10px;
                white-space: nowrap;
                font-size:13px;
                color: #C0C4CC;
            }
            .sortInput{
                height: 32px;
                width: 80px;
                -webkit-appearance: none;
                background-color: #FFF;
                background-image: none;
                border-radius: 4px;
                border: 1px solid #DCDFE6;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                color: #606266;
                display: inline-block;
                font-size: inherit;
                outline: 0;
                padding: 0 15px;
                -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                transition: border-color .2s cubic-bezier(.645,.045,.355,1);
            }
            .sortInput:hover {
                border-color: #C0C4CC;
            }
            .sortInput:focus {
                border-color: #409EFF;
                outline: 0;
            }
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none !important;
            }
            input[type="number"]{-moz-appearance:textfield;}
            .el-input {
                width: 80px;
            }
        }
        .right_help_box{
            position: fixed;
            top: 70px;
            right: -225px;
            height: 91vh;
            width: 225px;
            z-index: 10;
            box-sizing: border-box;
            border-top: 2px solid #409EFF;
            box-shadow: 2px 0px 6px 0px rgba(0,21,41,0.14);
            .show_helps{
                width: 12px;
                height: 50px;
                background-size:12px 50px !important;
                position: absolute;
                top: 30%;
                left: -12px;
                cursor: pointer;
                border-radius: 6px 0 0 6px;
            }
            .show_helps:hover{
                background-color: #ccc;
            }
            .show_icon{
                background-image: url('../../../common/images/other/show.png');
            }
            .hide_icon{
                background-image: url('../../../common/images/other/hide.png');
            }
            .title_box{
                display: flex;
                justify-content: space-between;
                border-left: 2px solid #409EFF;
                padding-left: 8px;
                span{
                    line-height: 16px;
                    font-weight: bold;
                }
                span:nth-of-type(2){
                    color: #409EFF;
                    font-size: 12px;
                    font-weight: normal;
                    cursor: pointer;
                }
                span:nth-of-type(2):hover{
                    color: rgb(29, 134, 238);
                }
            }
            &>p:nth-of-type(1){
                color:rgba(48,49,51,1);
                margin: 20px 0;
                font-weight: bold;
                // font-size: 15px;
                line-height:20px;
            }
            &>p:nth-of-type(2){
                color:rgba(144,147,153,1);
                line-height:18px;
                font-size: 12px;
                margin-bottom: 20px;
            }
            .issue_box{
                background-color: #F5F7FA;
                padding: 15px 12px;
                ul{
                    padding-left: 10px;
                    li{
                        list-style: disc;
                        margin-bottom: 15px;
                        a{
                            font-size:13px;
                            height:18px;
                            color:rgba(64,158,255,1);
                            line-height:18px;
                        }
                    }
                    li:nth-last-of-type(1){
                        margin-bottom: 0;
                    }
                }
            }
        }
        .show_helps_box{
            right: 0;
            transition: 1s all;
        }
        .hide_icon_box{
            right: -225px;
            transition: 1s all;
        }
    }
    .el-popover{
        .videoList-pr-code-upload{
            text-align: center;
            img{
                width: 160px;
                height: 160px;
            }
            .pr-code-text{
                color: $tcolor-blue;
                padding: 20px 0;
            }
            .btn-operate{
                @include flexBox(space-between);
                .el-input,input{
                    width: 210px;
                    height: 36px;
                    line-height: 36px;
                }
                .el-button{
                    min-width: 60px;
                }
            }
        }
    }
</style>
<style>
    .el-dialog__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: left;
    }
    .el-dialog {
        margin: 0!important;
    }
    .el-dialog .el-dialog__body {
        padding-right: 0px;
    }
</style>
